// client/src/components/pages/LexiStar/NotificationRules/ChannelOrder.jsx
//
// Ordered channel preference (FR-NTF-003/008): the first channel is tried
// first; when delivery fails, the next one is used (automatic fallback).

import React from 'react';
import { FaArrowUp, FaArrowDown, FaTimes } from 'react-icons/fa';
import ThemedSelect from '../../../common/ThemedSelect';
import { inputClasses } from '../StatusBoard/atoms';
import { RULE_CHANNELS, channelName } from './ruleLogic';

export default function ChannelOrder({
  value = [],
  onChange,
  options = RULE_CHANNELS,
  label = 'Channels',
  disabled = false,
}) {
  const move = (i, d) => {
    const next = [...value];
    const j = i + d;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };
  const remaining = options.filter((o) => !value.includes(o.value));
  return (
    <div className="space-y-2" role="group" aria-label={label}>
      <ol className="space-y-1.5">
        {value.map((c, i) => (
          <li
            key={c}
            className="flex items-center gap-2 rounded-lg border border-slate-200 bg-surface px-3 py-1.5"
          >
            <span className="w-5 text-xs font-semibold text-slate-400 tabular-nums">{i + 1}.</span>
            <span className="flex-1 text-sm text-slate-800">
              {channelName(c)}
              {i > 0 && <span className="ml-2 text-xs text-slate-500">fallback</span>}
            </span>
            {!disabled && (
              <>
                <button
                  type="button"
                  onClick={() => move(i, -1)}
                  disabled={i === 0}
                  aria-label={`Move ${channelName(c)} up`}
                  className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-30"
                >
                  <FaArrowUp size={10} />
                </button>
                <button
                  type="button"
                  onClick={() => move(i, 1)}
                  disabled={i === value.length - 1}
                  aria-label={`Move ${channelName(c)} down`}
                  className="p-1 text-slate-400 hover:text-slate-700 disabled:opacity-30"
                >
                  <FaArrowDown size={10} />
                </button>
                <button
                  type="button"
                  onClick={() => onChange(value.filter((x) => x !== c))}
                  aria-label={`Remove ${channelName(c)}`}
                  className="p-1 text-slate-400 hover:text-red-600"
                >
                  <FaTimes size={10} />
                </button>
              </>
            )}
          </li>
        ))}
      </ol>
      {!disabled && remaining.length > 0 && value.length < 5 && (
        <div className="w-56">
          <ThemedSelect
            aria-label={`Add to ${label.toLowerCase()}`}
            value=""
            onChange={(e) => e.target.value && onChange([...value, e.target.value])}
            className={inputClasses}
          >
            <option value="">Add a channel...</option>
            {remaining.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </ThemedSelect>
        </div>
      )}
    </div>
  );
}
